import type { Category } from './format';

export interface SeedExpense {
  name: string;
  category: Category;
  amount: number;
  notes: string;
}

export const SEED_MONTH = '2026-03';

export const FACTORY_SEED: SeedExpense[] = [
  { name: 'Vehicle Asset Finance (SBSAVAF)',     category: 'Fixed Hard Costs',     amount: 4797.01, notes: 'GoTyme Debit Order' },
  { name: 'Rent',                                category: 'Fixed Hard Costs',     amount: 1500.00, notes: 'GoTyme Monthly' },
  { name: 'Vehicle Insurance (AUTOGEN)',         category: 'Fixed Hard Costs',     amount: 1782.47, notes: 'GoTyme DebiCheck' },
  { name: 'Vodacom Combined Contract (Somila)',  category: 'Fixed Hard Costs',     amount: 1165.00, notes: 'Vodacom Contract' },
  { name: 'Vehicle Tracking (CarTrack)',         category: 'Services & Safety',    amount:  240.79, notes: 'Capitec Monthly' },
  { name: 'Baseline Groceries (Estimated)',      category: 'Living Allocations',   amount: 2500.00, notes: 'Checkers / Shoprite' },
  { name: 'Fuel & Transport (Estimated)',        category: 'Living Allocations',   amount: 1200.00, notes: 'Engen / Ride-hailing' },
  { name: 'Cellphone & Data (Estimated)',        category: 'Living Allocations',   amount:  455.00, notes: 'Prepaid bundles' },
  { name: 'Electricity',                         category: 'Living Allocations',   amount:  500.00, notes: 'Prepaid cash' },
  { name: 'Digital Subscriptions Cap',           category: 'Subscriptions & Caps', amount:  200.00, notes: 'Google Play / Apple' },
  { name: 'Dining Out & Takeaways Cap',          category: 'Subscriptions & Caps', amount:  200.00, notes: 'KFC / Pedros limit' },
  { name: 'Entertainment & Outings',             category: 'Subscriptions & Caps', amount:  100.00, notes: 'Leisure cap' },
  { name: 'TFG Account',                         category: 'Debt Paydown',         amount:  440.00, notes: 'Payoff Priority 1' },
  { name: 'Game / DionWired',                    category: 'Debt Paydown',         amount:  540.87, notes: 'Payoff Priority 2' },
];
